export const buildAvailableContactList = (
  allContacts,
  assignedContacts,
  selectedContacts = []
) => {
  const assignedContactIds = assignedContacts.map(contact => {
    return contact.contact.id;
  });
  const selectedContactIds = selectedContacts.map(contact => {
    return contact.value;
  });
  const excludedContactList = [...assignedContactIds, ...selectedContactIds];
  const availableContacts = [];
  allContacts.forEach(contact => {
    if (!excludedContactList.includes(contact.id)) {
      availableContacts.push({
        title: `${contact.firstName} ${contact.lastName}`,
        value: contact.id
      });
    }
  });
  return availableContacts;
};
